module.exports = __webpack_public_path__ + "static/media/bad-result.e48a5328.png";